import { call, put } from 'redux-saga/effects';

import { apiGeneral, queryBuilder, notify } from 'services';
import { IPaginateRequest } from 'interfaces/paginate-duck';
import { requestErrorHandler } from 'utils';
import { PaginateRtvActions } from 'store/ducks/settings/rtv';

export function* paginateRtvRequest(action: any) {
  try {
    const { query = {} } = action as IPaginateRequest;
    const queryString = queryBuilder(query);

    const { data: responseBody } = yield call(
      apiGeneral.get,
      `/rtv?${queryString}`
    );

    const { rtv, pagination } = responseBody;
    yield put(PaginateRtvActions.success(rtv, pagination));
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify('error', errorMessage);
    yield put(PaginateRtvActions.failure(errorMessage));
  }
}
